/** IAA 只读查询：使用独立日期闭区间与 App 缓存键，不复用付费收入或 range 查询。 */
import {
  type RewardedAdMetricsResponse,
  RewardedAdMetricsResponseSchema,
} from '@novel-admin/shared';
import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '~/api/client';

export function useRewardedAdMetrics(input: {
  appScope: string;
  from: string;
  to: string;
}) {
  return useQuery({
    queryKey: ['rewarded-ad-metrics', input.appScope, input.from, input.to],
    queryFn: async (): Promise<RewardedAdMetricsResponse> => {
      // @real — 业务与预估收入的未就绪字段保持缺失，不经零值 adapter。
      const data = await apiRequest<RewardedAdMetricsResponse>({
        method: 'GET',
        path: '/api/v1/metrics/rewarded-ads',
        query: { app_scope: input.appScope, from: input.from, to: input.to },
      });
      return RewardedAdMetricsResponseSchema.parse(data);
    },
    retry: false,
  });
}
